
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Paragraph } from '@ecl/website-components';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Paragraph size="lead" mdxType="Paragraph">
  Background utilities let you edit background colours of elements.
    </Paragraph>
    <h2>{`Background colour`}</h2>
    <p>{`By using classes `}<inlineCode parentName="p">{`ecl-u-bg-*`}</inlineCode>{` you can set the background colour of an element.
Available colours are:`}</p>
    <ul>
      <li parentName="ul">{`primary colours (blue, yellow, grey)`}</li>
      <li parentName="ul">{`black and white`}</li>
      <li parentName="ul">{`The `}<Link to="/ec/guidelines/colours/" mdxType="Link">{`blue palette`}</Link></li>
      <li parentName="ul">{`The `}<Link to="/ec/guidelines/colours/" mdxType="Link">{`yellow palette`}</Link></li>
      <li parentName="ul">{`The `}<Link to="/ec/guidelines/colours/" mdxType="Link">{`grey palette`}</Link></li>
      <li parentName="ul">{`The `}<Link to="/ec/guidelines/colours/" mdxType="Link">{`notification palette`}</Link></li>
    </ul>
    <p><strong parentName="p">{`Accessibility warning`}</strong></p>
    <p>{`When changing background colour, make sure to always keep a high enough contrast ratio (4.5:1 for normal text and 3:1 for large text).`}</p>
    <p>{`There are several online tools to check the contrast, for instance `}<a parentName="p" {...{
        "href": "https://webaim.org/resources/contrastchecker/"
      }}>{`Color Contrast Checker`}</a></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;